import { FormPage } from '@checkit/react-components';
import { EditIcon } from '@checkit/react-components/build/components/Icons';
import { omit } from 'ramda';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';
import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import { State } from '../../state';
import {
  getUserDefinedRole,
  isUpdateUserDefinedRoleSuccess,
  updateUserDefinedRole
} from '../actions';
import { UserDefinedRoleForm } from '../form/UserDefinedRoleForm';
import { UserDefinedRole, UserDefinedRoleCreateDto } from '../state';
import { messages } from './UpdateUserDefinedRole.translations';

export interface Props extends RouteComponentProps<{userDefinedRoleCode: string}> {
  role?: UserDefinedRole;
}

const stripName = omit(['name']);

export const UpdateUserDefinedRoleImpl: React.FC<Props> = ({
  history,
  match,
  role
}: Props) => {
  const { formatMessage } = useIntl();
  const dispatch = useAxiosDispatch( );

  const code = match.params.userDefinedRoleCode;

  useEffect(() => {
    if (!role) {
      dispatch(getUserDefinedRole(code));
    }
  }, [code, dispatch, role]);

  async function handleSubmit(data: UserDefinedRoleCreateDto): Promise<AnyAction> {
    const action = updateUserDefinedRole(code, stripName(data));
    let resultingAction;
    try {
      resultingAction = await dispatch(action);

      if (!isUpdateUserDefinedRoleSuccess(resultingAction)) {
        throw new Error('Resulting action of user-defined role creation is invalid');
      }

      dispatch(createSnackbar({
        message: formatMessage(messages['userDefinedRole.update.success']),
        options: { variant: 'success' }
      }));
    } catch (err) {
      dispatch(createSnackbar({
        message: formatMessage(messages['userDefinedRole.update.error']),
        options: { variant: 'error' }
      }));

      throw err;
    }
    return resultingAction;
  }

  return (
    <FormPage
      pageTitle={formatMessage(messages['userDefinedRole.update.pageTitle'])}
      pageIcon={<EditIcon />}
    >
      <UserDefinedRoleForm code={code} history={history} handleSubmit={handleSubmit} />
    </FormPage>
  );
};

const mapStateToProps = (state: State, props: Props) => ({
  role: state.userDefinedRoles.byCode[props.match.params.userDefinedRoleCode]
});
export default connect(mapStateToProps)(UpdateUserDefinedRoleImpl);
